import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { dropAddressFormSchema } from './drop-address-form.schema'

export const useDropAddressForm = () => {
  const formMethods = useForm({
    resolver: yupResolver(dropAddressFormSchema),
    defaultValues: dropAddressFormSchema.cast({}),
  })

  return { formMethods }
}
